import { ScrollRestoration } from "react-router";

import { CONTACT_STEP } from "../helpers/constants";
import { usePathname } from "../hooks/usePathname";

export const FormScrollRestoration = () => {
	const pathname = usePathname();
	if (pathname === CONTACT_STEP) return null;

	return <ScrollRestoration />;
};
